import { useContext } from "react";

import { PasteDialogContext } from "./PasteDialogContext";

export const usePasteDialog = () => useContext(PasteDialogContext);
